<script>
import ECharts from '../Charts/ECharts'

import calc from './calc'
import {TEXT_FONT_FAMILY} from './FactorCharts/chartStyle'

export default {
  name: 'RelatedChart',
  extends: ECharts,
  props: {
    chartTitle: {
      type: String
    },
    baseData: {
      required: true,
      type: Object
    },
    relatedData: {
      required: true,
      type: Object
    },
    invalid: {
      type: Boolean,
      default: false
    },
    auditRuleMap: {
      type: Object
    },
    scale: {
      type: Boolean,
      default: false
    },
    dataTimeFormatter: {
      type: String,
      default: 'YYYY-MM-DD HH'
    }
  },
  methods: {
    afterInit (chart) {
      chart.on('dblclick', this.onChartDBLClick)
      chart.on('legendselectchanged', this.onLegendSelectChanged)
    },
    destroy () {
      this.myChart.off('dblclick', this.onChartDBLClick)
    },
    setRelatedChart () {
      let {baseData, relatedData} = this
      let baseDataList = baseData.data
      let relatedDataList = relatedData.data
      let newBaseDataList = []
      let newRelatedDataList = []

      baseDataList.forEach((baseData, index) => {
        let relatedData = relatedDataList[index]

        if (!Number.isFinite(baseData.value) || !Number.isFinite(relatedData.value)) {
          return
        }

        newBaseDataList.push(baseData)
        newRelatedDataList.push(relatedData)
      })

      if (newBaseDataList.length > 0) {
        this.renderChart(true, newBaseDataList, newRelatedDataList)
      } else {
        this.renderChart(false, newBaseDataList, newRelatedDataList)
      }
    },
    renderChart (flag, xDataList, yDataList) {
      let {baseData, relatedData, chartTitle} = this
      let series = []
      let scatterValues = xDataList.map((xData, index) => [xData.value, yDataList[index].value, baseData, relatedData, xData, yDataList[index]])
      let normalPoints = this.normalPoints = []
      let exceptionPoints = this.exceptionPoints = []
      let zeroPoints = this.zeroPoints = []
      let normalXDataList = []
      let normalYDataList = []

      scatterValues.forEach(data => {
        let xFlag = data[4].flag
        let xAuditFlag = data[4].auditFlag
        let yFlag = data[5].flag
        let yAuditFlag = data[5].auditFlag

        if (data[0] === 0 && data[1] === 0) {
          zeroPoints.push(data)
        } else if ((!xFlag || xFlag === 'N' || !xAuditFlag || xAuditFlag === 'RESERVE') && (!yFlag || yFlag === 'N' || !yAuditFlag || yAuditFlag === 'RESERVE')) {
          normalPoints.push(data)
          normalXDataList.push(data[4])
          normalYDataList.push(data[data.length - 1])
        } else {
          exceptionPoints.push(data)
        }
      })

      if (flag) {
        let {a, b, r} = calc.calcRelated(normalXDataList, normalYDataList)
        series = [{
          name: `${baseData.name} vs ${relatedData.name}`,
          type: 'scatter',
          data: normalPoints.map((point, index) => [point[0], point[1], 'normalPoints', index])
        }]

        if (zeroPoints.length > 0) {
          series.push({
            name: '零值点',
            type: 'scatter',
            data: zeroPoints.map((point, index) => [point[0], point[1], 'zeroPoints', index]),
            color: '#ffff00'
          })
        }

        if (exceptionPoints.length > 0) {
          series.push({
            name: '异常点',
            type: 'scatter',
            data: exceptionPoints.map((point, index) => [point[0], point[1], 'exceptionPoints', index]),
            color: '#ff0000'
          })
        }

        series.push({
          id: 'y',
          name: this.getY(a, b, r),
          type: 'line',
          data: normalPoints.map(xData => [xData[0], a * xData[0] + b]),
          // showSymbol: false
          itemStyle: {
            opacity: 0
          },
          silent: true
        })
      }

      let chartOpt = {
        toolbox: {
          feature: {
            saveAsImage: {}
          },
          right: 23
        },
        tooltip: {
          appendToBody: true,
          formatter: params => {
            let {data, seriesName} = params
            let eles = [
              `<div style="font-size:14px;color:#666;font-weight:400;line-height:1;">${params.marker}<span>${seriesName}</span></div>`,
              '<div style="margin: 10px 0 0;line-height:1.4;">'
            ]
            let value = this[data[2]][data[3]]

            if (params.seriesType === 'scatter') {
              eles.push(
                '<div>',
                `<span style="font-size:14px;color:#666;font-weight:400;margin-left:2px">时间:</span>`,
                `<span style="float:right;margin-left:20px;font-size:14px;color:#666;font-weight:900">${new Date(value[4].dataTime).format(this.dataTimeFormatter)}</span>`,
                '</div>'
              )
            }

            const {displayFlags: xDisplayFlags = [], isHaveIntegral: xIsHaveIntegral} = value[4] || {}
            const xFlags = []

            if (xIsHaveIntegral) {
              xFlags.push('重积分')
            }

            if (xDisplayFlags[0]) {
              xFlags.push(xDisplayFlags[0])

              if (xDisplayFlags[1]) {
                xFlags[xFlags.length - 1] += `: ${xDisplayFlags[1]}`
              }
            }

            const {displayFlags: yDisplayFlags = [], isHaveIntegral: yIsHaveIntegral} = value[5] || {}
            const yFlags = []

            if (yIsHaveIntegral) {
              yFlags.push('重积分')
            }

            if (yDisplayFlags[0]) {
              yFlags.push(yDisplayFlags[0])

              if (yDisplayFlags[1]) {
                yFlags[yFlags.length - 1] += `: ${yDisplayFlags[1]}`
              }
            }

            eles.push(
              '<div>',
              `<span style="font-size:14px;color:#666;font-weight:400;margin-left:2px">x:</span>`,
              `<span style="float:right;margin-left:20px;font-size:14px;color:#666;font-weight:900">${Number(value[0].toFixed(3))} ${value[2].unit || ''}${(xFlags.length > 0) ? `(${xFlags.join(', ')})` : ''}</span>`,
              '</div>',

              '<div>',
              `<span style="font-size:14px;color:#666;font-weight:400;margin-left:2px">y:</span>`,
              `<span style="float:right;margin-left:20px;font-size:14px;color:#666;font-weight:900">${Number(value[1].toFixed(3))} ${value[3].unit || ''}${(yFlags.length > 0) ? `(${yFlags.join(', ')})` : ''}</span>`,
              '</div>',

              '</div>',
              '</div>'
            )

            return eles.join('')
          }
        },
        legend: {
          top: chartTitle ? 25 : -5,
          left: 'center',
          width: '70%',
          selected: {
            '零值点': false,
            '异常点': false
          }
        },
        grid: {
          top: chartTitle ? 70 : 55,
          right: 40,
          bottom: 40,
          left: 40,
          containLabel: true
        },
        xAxis: {
          type: 'value',
          name: `${baseData.name || ''} ${baseData.unit ? `(${baseData.unit})` : ''}`,
          nameLocation: 'center',
          nameGap: 25,
          splitLine: {
            show: false
          },
          axisLine: {
            onZero: false,
            lineStyle: {
              color: '#aaaaaa'
            }
          },
          scale: this.scale
        },
        yAxis: {
          type: 'value',
          name: `${relatedData.name || ''} ${relatedData.unit ? `(${relatedData.unit})` : ''}`,
          nameLocation: 'center',
          nameGap: 45,
          splitLine: {
            show: false
          },
          axisLine: {
            onZero: false,
            lineStyle: {
              color: '#aaaaaa'
            }
          },
          axisLabel: {
            formatter: value => Number(value.toFixed(3))
          },
          scale: this.scale
        },
        series
      }

      if (chartTitle) {
        chartOpt.title = {
          text: chartTitle,
          left: 'center',
          textStyle: {
            fontFamily: TEXT_FONT_FAMILY
          }
        }
      }

      this.setOpt(chartOpt)
    },
    onChartDBLClick (event) {
      this.$emit('dblclick', event.data)
    },
    onLegendSelectChanged (param) {
      let seriesName = param.name

      if (seriesName.indexOf('y=') > -1) {
        return
      }

      let chartOpt = this.getOpt()
      let {series} = chartOpt
      let {selected} = param

      series = series.filter(({name}) => name.indexOf('y=') === -1 && selected[name])
      let {aList, bList} = series.reduce((map, seriesItem) => seriesItem.data.reduce((map, data) => {
        let value = this[data[2]][data[3]]
        map.aList.push(value[4])
        map.bList.push(value[value.length - 1])
        return map
      }, map), {
        aList: [],
        bList: []
      })
      let nObj = calc.calcRelated(aList, bList)

      if (nObj) {
        let {a, b, r} = nObj

        this.setOpt({
          series: [{
            id: 'y',
            name: this.getY(a, b, r),
            silent: true,
            data: aList.map(xData => [xData.value, a * xData.value + b])
            // data: []
          }]
        }, true)
      }
    },
    getY: (a, b, r) => `y=${a.toFixed(3)}x${b < 0 ? '-' : '+'}${Math.abs(b.toFixed(3))},R=${r.toFixed(3)}`,
    clearTimer () {
      clearTimeout(this.timer)
    }
  },
  watch: {
    baseData: {
      immediate: true,
      handler (newVal) {
        this.clearTimer()

        if (newVal) {
          this.timer = setTimeout(() => {
            this.setRelatedChart()
          }, 0)
        }
      }
    }
  },
  beforeDestroy () {
    this.clearTimer()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Data/RelatedChart.vue